import { render, staticRenderFns } from "./CustomerWorkFlos.vue?vue&type=template&id=543168f8&scoped=true&"
import script from "./CustomerWorkFlos.vue?vue&type=script&lang=js&"
export * from "./CustomerWorkFlos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543168f8",
  null
  
)

export default component.exports